<template>
  <div class="checkboxlist">
    <div v-for="check in checklistsData"  :key="check.id" class="checkboxitem" :class="{ 'checked': check.status }">
      <o-checkbox :disabled="!Boolean(referenceType)" v-model="check.status" @update:modelValue="updateItem(check)">{{ check.description }} </o-checkbox>
      <small v-if="check.status">{{ $filters.note_date(check.updated_at) }}</small>
      <a href="#" @click.prevent="removeCheckItem(check)"><i class="fa fa-trash"></i></a>
    </div>
    <div class="new-check">
      <o-checkbox disabled />
      <o-input :model-value="newItemDecription" @update:modelValue="newItemDecription = $event" placeholder="Add item" />
      <button @click.prevent="addItem" class="button is-info" :disabled="!newItemDecription">Add</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
  },

  mixins: [],

  props: {
    referenceType: {
      type: String,
      default: ''
    },
    referenceId: {
      type: Number,
      default: 0
    },
    itemList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.fetchChecklists( { reference_type: this.referenceType, reference_id: this.referenceId } )
  },
  data() {
    return {
      newItemDecription : ''
    }
  },
  model: {
    prop: 'itemList',
    event: 'input'
  },
  computed: {
    ...mapGetters(['checklistsByReference']),
    checklistsData() {
      return Boolean(this.referenceType) ? this.checklistsByReference(this.referenceType, this.referenceId) : this.itemList
    }
  },
  methods: {
    ...mapActions(['fetchChecklists', 'createChecklist', 'updateChecklist', 'removeChecklist']),
    addItem() {
      if(Boolean(this.referenceType)) {
        this.createChecklist({ reference_type: this.referenceType, reference_id: this.referenceId, description: this.newItemDecription, status: false})
      } else {
        this.itemList.push({ description: this.newItemDecription })
        this.handleInput()
      }
      this.newItemDecription = ''
    },
    updateItem(item) {
      this.updateChecklist(item)
    },
    removeCheckItem(item) {
      this.confirmMessage('Remove Item', 'Do you want to remove this item?', 'Remove').then(p => {
        if(Boolean(this.referenceType)) {
          this.removeChecklist(item)
          $(".checkboxitem").load(location.href+" .checkboxitem>*","");
        } else {
          this.itemList.splice(this.itemList.indexOf(item), 1)
          $(".checkboxitem").load(location.href+" .checkboxitem>*","");
        }
      })
    },
    handleInput(value) {
      this.$emit('input', value ? value : this.itemList)
    }
  }
}
</script>
<style>
.checkboxlist {
  display: grid;
  padding: 5px;
  border: 1px solid #ccc;
  margin-top: 10px;
  background-color: #fff; }

.checkboxlist input[type=checkbox] + .check {
  background-color: #fff !important; }

.checkboxlist input[type=checkbox]:checked + .check {
  background-color: #000 !important;
  border: 0px !important; }

.checkboxlist a {
  margin-bottom: 5px;
  margin-left: 10px; }

.checkboxlist .checkboxitem {
  border-bottom: 1px solid #ccc;
  padding: 4px 10px 4px 0px;
  display: flex;
  min-height: 50px;
  position: relative; }

.checkboxlist label.o-checkbox.checkbox {
  margin-left: 0.5em;
  margin-bottom: 5px;
  width: calc(100% - 30px); }

.checkboxlist .checked span.control-label {
  text-decoration: line-through;
  color: #ccc; }

.checkboxlist small {
  position: absolute;
  bottom: 0px;
  right: 0px; }

.new-check {
  border: 1px #c0c0c0 dashed;
  min-width: 200px;
  max-width: 400px;
  padding: 6px 0px;
  margin-top: 10px;
  display: inline-flex; }

</style>